import videoSources from 'widget/player-widget/constants/video-sources';

import Vimeo from './video/external/vimeo';
import Youtube from './video/external/youtube';
import Facebook from './video/external/facebook';


const playersMap = {
  [videoSources.YOUTUBE]: Youtube,
  [videoSources.VIMEO]: Vimeo,
  [videoSources.FACEBOOK]: Facebook,
};


export default class ExternalPlayer extends React.Component {

  static propTypes = {
    videoItem: React.PropTypes.object.isRequired,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    className: React.PropTypes.string,
  };

  render() {
    const { videoItem } = this.props;

    if (!videoItem) {
      return null;
    }

    const { id, externalId, mediaExternUrl, videoSource } = videoItem;

    const props = {
      ...this.props,
      showControls: true,
      src: mediaExternUrl,
    };

    const ExternalPlayer = playersMap[videoSource];

    if (!ExternalPlayer) {
      return null;
    }

    return (
      <ExternalPlayer {...props}
                      key={id || externalId} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/new-player-external.js